<template>
  <div>
    <v-dialog :value="show" @input="fechar" max-width="1000">
      <v-card>
        <v-card-title>Cadastro Dispositivo</v-card-title>
        <v-card-text>
          <v-form lazy-validation ref="form">
            <v-row>
              <v-col cols="12" md="4" sm="12">
                <v-text-field dense outlined label="IMEI" v-model="dados.imei" />
              </v-col>

              <v-col cols="12" md="4" sm="12">
                <v-text-field dense outlined label="ICCD" v-model="dados.iccd" />
              </v-col>

              <v-col cols="12" md="4" sm="12">
                <v-text-field dense outlined label="SSAID" v-model="dados.ssaid" />
              </v-col>

              <v-col cols="12" md="6" sm="12">
                <v-select
                  dense
                  outlined
                  label="Ativo"
                  :items="ativos"
                  v-model="dados.ativo"
                />
              </v-col>
              <v-col cols="12" md="6" sm="12">
                <v-text-field dense outlined label="Apelido" hide-details v-model="dados.apelido" />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="primary" outlined @click="fechar">Fechar</v-btn>
          <v-btn color="primary" @click="salvar(dados)">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "ModalDispositivo",
  props: {
    dispositivo: {
      type: Object,
      default: () => ({}),
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    dispositivo(newValue) {
      console.log(newValue);
      this.dados = { ...newValue};
    },
  },
  data() {
    return {
      dados: {},
      ativos: [
        { text: "Sim", value: true },
        { text: "Não", value: false },
      ],
      imeiRules: [
        (v) => !!v || "Imei é obrigatório",
        (v) => (v && v.length <= 15) || "o Imei tem no máximo 15 caracteres",
      ],
      iccdRules: [
        (v) => !!v || "Iccd é obrigatório",
        (v) => (v && v.length <= 22) || "o Imei tem no máximo 22 caracteres",
      ]
    };
  },
  methods: {
    fechar() {
      this.$emit("fechar");
      this.$refs.form.reset();
    },
    salvar(dispositivo) {

	  var imei 	= new Boolean(dispositivo.imei);
	  var iccd 	= new Boolean(dispositivo.iccd);
	  var ssaid = new Boolean(dispositivo.ssaid);

	  if (imei == false && iccd == false && ssaid == false) {
	    alert('Informe o IMEI e ICCD ou o SSAID');
	    return;

	  } else if (imei == true && iccd == false) {
	    alert('Informe o ICCD');
	    return;

	  } else if (iccd == true && imei == false) {
	    alert('Informe o IMEI');
	    return;

	  } else {
		this.$emit("submit", { ...dispositivo });
		this.$refs.form.reset();
	  }
    },
  },
};
</script>
